import Image from "next/image";
import RenderText from "@/kyna/forms/RichTextField/plugins/RenderText";
import { useRouter } from "next/router";
import { useState } from "react";
import Head from "next/head";
import AddModal from "@/kyna/view/_app/users/modules/AddModal";

import { format } from "date-fns";

import HeaderNav from "@/kyna/includes/HeaderNav";
import Footer from "@/kyna/includes/Footer";
import AppLogo from "../../public/assets/img/app-logo.png";
import Link from "next/link";
import ApplicantsModal from "@/kyna/view/_app/hr/modules/ApplicantsModal";
import KNToaster from "@/kyna/ui/toaster/KNToaster";
import { useFormik } from "formik";
import { ABSOLUTE_URL } from "@/kyna/lib/global";
import parse from "html-react-parser";

const JobDetails = ({ data }) => {
  const formik = useFormik({
    initialValues: {
      qualification: data?.qualification,
      duties_and_responsibilties: data?.duties_and_responsibilties,
    },
  });

  const { query } = useRouter();

  const [isAddModalOpen, setAddModalOpen] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);

  return (
    <>
      <Head>
        <title>Careers - {data?.title}</title>
        <meta name="description" content={data?.description} />
      </Head>

      {/* MAIN NAVIGATION */}
      <HeaderNav />
      <section className="max-w-screen-xl mx-auto lg:mt-44 mt-36 sm:px-10 px-8 lg:pb-24 pb-8">
        <div className="grid border-b border-gray-200 pb-6 mb-6">
          <h1 className="font-semibold text-blue text-center md:text-4xl text-3xl leading-normal uppercase tracking-wider md:mb-4 mb-1">
            PMHA is hiring
          </h1>
          <p className="font-Courgette text-gray-700 text-center md:text-2xl text-xl">
            Join our growing team and be part of our advocacy!
          </p>
        </div>

        <div className="grid lg:grid-cols-2 grid-cols-1 gap-10 pt-8">
          <div className="lg:hidden block text-center">
            <Image
              src={
                data?.media?.path ? data?.media?.path : "/assets/img/img1.jpg"
              }
              alt="Job Illustration"
              width={500}
              height={300}
              className="object-cover rounded-lg"
            />
          </div>
          <div className="">
            {/* JOB DESCRIPTION */}
            <div className="grid mb-5">
              <h2 className="text-black/90 text-2xl">{data?.title}</h2>
              <p className="">{data?.description}</p>
            </div>

            {/* JOB DETAILS */}
            <div className="grid xl:grid-cols-3 grid-cols-2 gap-x-3 items-start mb-2">
              <div className="col-span-1">
                <p className="text-gray-500 text-base font-semibold uppercase tracking-wider mb-0">
                  Branch:
                </p>
              </div>
              <div className="xl:col-span-2 col-span-1">
                <p className="text-gray-800 text-base mb-0">
                  {data?.branch?.name}
                </p>
              </div>
            </div>

            <div className="grid xl:grid-cols-3 grid-cols-2 gap-x-3 items-start mb-2">
              <div className="col-span-1">
                <p className="text-gray-500 text-base font-semibold uppercase tracking-wider mb-0">
                  Job Type:
                </p>
              </div>
              <div className="xl:col-span-2 col-span-1">
                <p className="text-gray-800 text-base mb-0">{data?.job_type}</p>
              </div>
            </div>

            <div className="grid xl:grid-cols-3 grid-cols-2 gap-x-3 items-start mb-2">
              <div className="col-span-1">
                <p className="text-gray-500 text-base font-semibold uppercase tracking-wider mb-0">
                  No. of openings:
                </p>
              </div>
              <div className="xl:col-span-2 col-span-1">
                <p className="text-gray-800 text-base mb-0">
                  {data?.no_of_openings}
                </p>
              </div>
            </div>

            <div className="grid xl:grid-cols-3 grid-cols-2 gap-x-3 items-start mb-2">
              <div className="col-span-1">
                <p className="text-gray-500 text-base font-semibold uppercase tracking-wider mb-0">
                  End of filing:
                </p>
              </div>
              <div className="xl:col-span-2 col-span-1">
                <p className="text-gray-800 text-base mb-0">
                  {data?.schedule
                    ? format(new Date(data?.schedule), "MMMM dd, yyyy")
                    : null}
                </p>
              </div>
            </div>

            <div className="grid lg:block hidden">
              <div className="mt-5">
                <button
                  onClick={() => setIsOpenModal(true)}
                  className="btn-secondary rounded-full text-lg font-semibold uppercase tracking-wider px-8"
                >
                  Apply Now
                </button>
              </div>
            </div>
          </div>
          <div className="lg:block hidden">
            <Image
              src={
                data?.media?.path ? data?.media?.path : "/assets/img/img1.jpg"
              }
              alt="Job Illustration"
              className="rounded-lg"
              width={1440}
              height={810}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 lg:gap-10 gap-5 pt-10">
          <div className="">
            <h3 className="text-blue text-base uppercase tracking-wider mb-3">
              Qualifications
            </h3>
            {data?.qualification ? (
              <div className="job-post-section">
                {parse(data?.qualification)}
              </div>
            ) : null}
          </div>

          <div className="">
            <h3 className="text-blue text-base uppercase tracking-wider mb-3">
              Duties &amp; Responsibilites
            </h3>
            {data?.duties_and_responsibilties ? (
              <div className="job-post-section">
                {parse(data?.duties_and_responsibilties)}
              </div>
            ) : null}
          </div>

          <div className="lg:hidden grid">
            <div className="text-center mt-3">
              <button
                onClick={() => setIsOpenModal(true)}
                className="btn-secondary rounded-full text-lg font-semibold uppercase tracking-wider px-8"
              >
                Apply Now
              </button>
            </div>
          </div>
        </div>
      </section>
      <ApplicantsModal
        isOpenModal={isOpenModal}
        setIsOpenModal={setIsOpenModal}
        data={data}
      />
      <KNToaster />

      {/* FOOTER */}
      <Footer />
    </>
  );
};

export async function getServerSideProps({ params }) {
  const BASE_URL = process.env.NEXT_PUBLIC_VERCEL_URL;
  const X_API_KEY = process.env.NEXT_PUBLIC_KYNA_API_KEY;

  let myHeaders = new Headers();
  myHeaders.append("X-API-KEY", X_API_KEY);

  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  const res = await fetch(
    `${BASE_URL}/api/jobs/?limit=1&slug=${params.slug}`,
    requestOptions
  );
  const data = await res.json();
  console.log(data?.result);
  /* if (isEmpty(data?.result)) {
      return {
        redirect: {
          destination: "/404",
          permanent: false,
        },
      };
    } */
  return {
    props: {
      data: data?.result,
    },
  };
}

export default JobDetails;
